import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';
import images from '../../constants/images';
import LanguageSelector from '../components/LanguageSelector';
import NavBarRightSwitch from './NavBarRightSwitch';
import Translator from '../components/helpers/Translator';
import AppLink from '../../routing/helpers/AppLink';
import { AppRemixIcon } from '@/layout/AppComponents';
import { routePath } from '@/routing/helpers/router';
import minions from '@/minions/minions';

const NavBar = () => {
  const location = useLocation();
  const global = useSelector((state) => state.global);
  const auth = useSelector((state) => state.auth);
  const doubleAuth = useSelector(
    (state) => state?.auth?.permissions?.client?.global?.doubleAuth,
  );
  const [showNavbar, setShowNavbar] = useState(false);
  const user = useSelector((state) => state.auth?.user);
  const [isForceChangePassword] = useState(
    user?.isForceChangePassword === true,
  );
  const [isForceDoubleAuth] = useState(
    doubleAuth?.force === true && !user?.googleAuthenticatorSecret,
  );
  const [route, setRoute] = useState(null);

  useEffect(() => {
    if (isForceChangePassword) {
      setRoute('user_change_password');
    } else if (isForceDoubleAuth) {
      setRoute('user_double_auth');
    }
  }, []);

  useEffect(() => {
    setShowNavbar(!location?.pathname?.includes('/communication-pipeline/'));
  }, [location]);

  if (!showNavbar) return null;

  return (
    <>
      <nav
        className={`navbar navbar-dark sticky-top ${
          global.urlData.rootProject.includes('wldev.net')
            ? 'bg-primary' /* WIP */
            : 'bg-primary'
        } flex-md-nowrap p-0`}
      >
        <AppLink path={route || 'user_home'} className="navbar-brand ml-3">
          <img
            alt=""
            src={images.navbarLogo}
            style={{ height: '20px', maxWidth: '100%' }}
            className="img-fluid"
          />
          {auth.user?.isAdmin && ' [ADMIN]'}
        </AppLink>
        <div className="flex-grow-1 text-white">
          <Routes>
            <Route
              path={routePath('user_module_legalCompliance_evaluation')}
              exact
              element={
                <ModuleName>
                  <Translator file="module-legalCompliance" name="gclName" />
                </ModuleName>
              }
            />
            <Route
              path={routePath('user_module_globalLegalCompliance_evaluation')}
              exact
              element={
                <ModuleName>
                  <Translator
                    file="module-globallegalCompliance"
                    name="global.legal.compliance"
                  />
                </ModuleName>
              }
            />
            <Route
              path={routePath('user_module_correctiveActions_base')}
              exact
              element={
                <ModuleName>
                  <Translator
                    file="module-correctiveActions"
                    name="task.manager"
                  />
                </ModuleName>
              }
            />
            <Route
              path={routePath('user_module_resourceManager_resource_home')}
              exact
              element={
                <ModuleName>
                  <Translator
                    file="module-resourceManager"
                    name="resource.manager"
                  />
                </ModuleName>
              }
            />{' '}
            <Route path="*" element={<></>} />
          </Routes>
        </div>
        <NavList className="navbar-nav px-3 flex-row align-items-center">
          <NavBarRightSwitch />
          <LanguageSelector />
          <Dropdown as="li" className="nav-item dropdown mr-2" align="end">
            <Dropdown.Toggle as="a" variant="default" className="nav-link">
              <AppRemixIcon icon="user" color="white" size={16} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <AppLink path={route || 'user_home'} className="dropdown-item">
                {`${auth.user.user} - ${auth.user.name}`}
              </AppLink>
              {auth?.permissions?.client?.global?.changePassword !==
                undefined &&
                auth?.permissions?.client?.global?.changePassword !== false && (
                  <AppLink
                    path={route || 'user_change_password'}
                    className="dropdown-item"
                  >
                    <Translator
                      file="client"
                      name="client.user.changepassword"
                    />
                  </AppLink>
                )}
              {auth?.permissions?.client?.global?.doubleAuth !== undefined &&
                auth?.permissions?.client?.global?.doubleAuth !== false && (
                  <AppLink
                    path={route || 'user_double_auth'}
                    className="dropdown-item"
                  >
                    <Translator file="client" name="Doble autenticación" />
                  </AppLink>
                )}
              <Dropdown.Item as="span" onClick={minions.auth.logout}>
                <Translator file="user" name="log.out" />
                <AppRemixIcon icon="logout-circle" className="float-right" />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </NavList>
      </nav>
    </>
  );
};

export default NavBar;

const NavList = styled.ul`
  .nav-item {
    cursor: pointer;
    padding: 0 6px;
    .nav-link {
      &::after {
        display: none;
      }
    }
  }
`;
const ModuleName = styled.span`
  padding-left: 46px;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
`;
